import { ProjectParentTypename } from "shared/types/Project"

import { ChildPositionData } from "entities/project-children/lib/getChildMoveData"

export function didMove(
  childPositionData: ChildPositionData
): childPositionData is {
  prevPosition: number
  prevParentID: string
  prevParentType: ProjectParentTypename
  nextParentID: string
  nextParentType: ProjectParentTypename
  nextPosition: number
} {
  if (
    !childPositionData.prevParentID ||
    !childPositionData.prevParentType ||
    !childPositionData.nextParentType ||
    !childPositionData.nextParentID
  ) {
    return false
  }
  return (
    childPositionData.prevPosition !== childPositionData.nextPosition ||
    childPositionData.prevParentID !== childPositionData.nextParentID
  )
}
